import { render, staticRenderFns } from "./CompanyMessages.vue?vue&type=template&id=a306ee96&scoped=true&"
import script from "./CompanyMessages.vue?vue&type=script&lang=js&"
export * from "./CompanyMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a306ee96",
  null
  
)

export default component.exports